export const userRoleItems = ["ADMIN", "WAITER"];
export const notificationTypeItems = ["SUCCESS", "ERROR", "INFO", "WARNING"];

//* Start Convert To Color
export const convertRoleToText = (role) => {
  let result = null;
  switch (role) {
    case userRoleItems[0]:
      result = "ادمین";
      break;
    case userRoleItems[1]:
      result = "سالن دار";
      break;

    default:
      break;
  }
  return result;
};
export const convertNotificationTypeToColor = (type) => {
  let result = "";
  switch (type) {
    case notificationTypeItems[0]:
      result = "success";
      break;
    case notificationTypeItems[1]:
      result = "danger";
      break;
    case notificationTypeItems[2]:
      result = "info";
      break;
    case notificationTypeItems[3]:
      result = "warning";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
//* End Convert To Color

//* Start Convert To Path
export const convertRoleToPath = (role) => {
  let result = "";
  switch (role) {
    case userRoleItems[0]:
      result = "admin";
      break;
    case userRoleItems[1]:
      result = "waiter";
      break;

    default:
      break;
  }
  return result;
};
//* End Convert To Path
